import TeamStatistics from 'components/general/TeamStatistics'

function BkbTeamStats({ data }) {

  const stats = [
    { code: 'LEADING'},
    { code: 'TIED_NUM', center: true },
    { code: 'LEAD_CHANGES', center: true },
    { code: 'SCORE_RUN_MAX', component: 'type3', paint: 'SCORE' },
    { code: 'LEAD_MAX' },
    { code: 'BENCH', component: 'type5', paint: 'PTS' },
    { code: 'FAST_BRK', component: 'type5', paint: 'PTS' },
    { code: '2CHANCE', component: 'type5', paint: 'PTS' },
    { code: 'PAINT', component: 'type4', paint: 'PTS' },
    { code: 'TO', header:'PTO', component: 'type5', paint: 'PTS' },
    { code: 'PLUS_MINUS' },
    { code: 'FD' },
    { code: 'PF' },
    { code: 'BLC' },
    { code: 'ST' },
    { code: 'TO' },
    { code: 'ASSIST' },
    { code: 'REB' },
    { code: 'DR', component: 'type5', paint: 'REB' },
    { code: 'OR', component: 'type5', paint: 'REB' },
    { code: 'FT', component: 'type2' },
    { code: 'P3', component: 'type2' },
    { code: 'P2', component: 'type2' },
    { code: 'FG', component: 'type2' }
  ]

  return (<>
    <TeamStatistics data={data?.results} stats={stats} />
  </>);
}

export default BkbTeamStats;